import { Component, Input } from '@angular/core'
import { FormControl } from '@angular/forms';
import { CustomValidator } from 'src/@shared/custom.validator';

@Component({
    selector: 'validation-message',
    template: '<div *ngIf="errorMessage !== null" class="clr-error control-invalid"><span class="clr-subtext">{{errorMessage}}</span></div>'
    //'<div *ngIf="errorMessage !== null">{{errorMessage}}</div>',

})

export class ValidationMessageComponent{
    @Input() control: FormControl;

    get errorMessage(){
        for (let errorName in this.control.errors) {
            if (this.control.hasError(errorName) && this.control.touched) {
                let error = CustomValidator.getValidatorErrorMessage(errorName, this.control.getError(errorName));
                return error;
            }
        }
        return null;
    }
}